/**
 * True when the given pathname is under the embed render tree
 * (`/embed/*`). Used both at module level (with `window.location.pathname`)
 * and inside React components (with `useLocation().pathname`).
 */
export const isEmbedPath = (pathname: string): boolean => pathname.startsWith("/embed/");
